import { createApp, type Plugin } from 'vue'
import { createPinia } from 'pinia'
import { createBootstrap } from 'bootstrap-vue-next/plugins/createBootstrap'
import { setupApp } from '@/typings/Helpers'

import App from './App.vue'
import router from './router'

import VueApexCharts from 'vue3-apexcharts'
import Sentry from '@/plugins/sentry'

import jQuery from 'jquery'
window.$ = window.jQuery = jQuery

import moment from 'moment'
window.moment = moment

import 'simplebar'
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css'
import 'daterangepicker/daterangepicker.css'
import 'vue-multiselect/dist/vue-multiselect.css'
import 'jquery-toast-plugin/dist/jquery.toast.min.css'
import 'jstree/dist/themes/default/style.min.css'
import 'vue3-form-wizard/dist/style.css'
import 'bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css'
import 'bootstrap-timepicker/css/bootstrap-timepicker.min.css'
import 'flatpickr/dist/flatpickr.min.css'
import '@/assets/scss/app-saas.scss'
import '@/assets/scss/icons.scss'
import '@/assets/chart-tooltip.css'

const pinia = createPinia()
const app = createApp(App)

const MetaPlug: Plugin = {
  install: (app: any) => {
    app.mixin({
      methods: {
        useMeta(item: { [key: string]: any }) {
          document.head.querySelector('title')!.innerHTML = item['title'] + ' | PacSort by 21 gram'
        },
      },
    })
  },
}

app.use(pinia)
app.use(Sentry)
app.use(router)
app.use(createBootstrap())
app.use(MetaPlug)
app.component('apexchart', VueApexCharts)
;(async () => {
  await setupApp(app)
})()
